import * as React from 'react';
import {PaymentObject} from 'api/student/types';
import Table, {TableVariant} from './Table';
import getPriceLabel from '../helpers/get-price-label';
import {getUserByID} from '../api/user/requests';
import validateResponse from '../helpers/validate-response';
import isError from '../helpers/isError';
import {UserObject} from '../stores/UserStore';

export interface PaymentTableProps {
  payments: PaymentObject[];
}

/**
 *
 * @param {PaymentTableProps} props
 * @return {React.ReactElement<PaymentTableProps>}
 * @constructor
 */
export default function PaymentTable(
    props: PaymentTableProps,
): React.ReactElement<PaymentTableProps> {
  /**
   * Get status label.
   * @param {string} status
   * @return {string}
   */
  function getStatus(status: string): string {
    switch (status) {
      case 'pending': return 'Ожидание';
      default: return status;
    }
  }

  /**
   * Get the data.
   * @return {{
   *   student: string,
   *   course: string,
   *   sum: string,
   *   paymentStatus: string
   * }[]}
   */
  function getData() {
    return props.payments.map((payment) => ({
      course: payment.product.title,
      student: getUserByID(payment.userID),
      paymentStatus: getStatus(payment.status),
      sum: getPriceLabel({
        amount: payment.order.amount,
        currency: payment.order.currency,
      }),
    }));
  }

  props.payments.forEach((payment) => {
    console.log({
      course: payment.product.title,
      student: getUserByID(payment.userID),
      paymentStatus: getStatus(payment.status),
      sum: getPriceLabel({
        amount: payment.order.amount,
        currency: payment.order.currency,
      }),
    });
  });

  return (
    <Table
      variant={TableVariant.Accent}
      columns={[
        {Header: 'Название курса', accessor: 'course'},
        {Header: 'Студент', accessor: 'student'},
        {Header: 'Статус', accessor: 'paymentStatus'},
        {Header: 'Сумма', accessor: 'sum'},
      ]}
      data={getData()}
    />
  );
}
